<template>
  <div class="titled">
    <div class="left">
      <!-- <img class="img" src="" alt=""> -->
      <span
        style="margin-right: 10px; margin-left: 40px; font-size: 18px; color: #999; font-weight: bold;"
        >选择设备</span
      >
      <div class="img_txt">
        <div class="p">
          <div class="nn">
            <el-select
              v-model="value"
              placeholder="请选择"
              @change="selectChange_fn"
            >
              <el-option
                v-for="item in options"
                :key="item.deviceNo"
                :label="item.deviceName"
                :value="item.deviceNo"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="name"
            v-if="num == 2"
            style="font-size: 18px; color: #999; font-weight: bold;margin-right: 10px;"
          >
            时间段
          </div>
          <el-select
            v-if="num == 2"
            v-model="value2"
            placeholder="请选择"
            @change="selectChange_fn"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" style="margin-left:10px" @click="getList"
            >查询</el-button
          >
        </div>
        <!-- <div class="p">
          <div class="n">1AT1-TRAFO INCOMING(SN BH 123456)</div>
          <div class="t">已连接 <i class="el-icon-paperclip"></i></div>
        </div> -->
      </div>
    </div>
    <div class="right">
      <div class="ul">
        <div
          class="li"
          v-for="(e, i) in d_list"
          :key="i"
          v-show="i > 3"
          :class="{ active: i == num2 }"
          @click="changed(i)"
        >
          {{ e }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { findDevicesList } from "../../../api/maintain.js";
export default {
  props: {
    num: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      options2: [
        {
          value: "DAY",
          label: "日",
        },
        {
          value: "MON",
          label: "月",
        },
        {
          value: "YEAR",
          label: "年",
        },
      ],
      options: [
        {
          deviceName: "空调",
          deviceNo: 1,
        },
        {
          deviceName: "电表",
          deviceNo: 2,
        },
        {
          deviceName: "照明",
          deviceNo: 3,
        },
        {
          deviceName: "水表",
          deviceNo: 4,
        },
      ],
      value: 1,
      value2: "",
      num2: 0,
      areaTree: false,
      deviceName: "设备",
      d_list: ["总览", "数据分析", "报警事件", "维护", "文档", "配置"],
    };
  },
  computed: {
    setDeviceName() {
      return this.$store.cacheStore.state.setDevice;
    },
  },
  watch: {
    setDeviceName: function(val) {
      this.value = val.deviceName;
    },
  },
  mounted() {
    this.num2 = this.num;
    setFz();
    //  屏幕的宽度改变之后
    window.onresize = function() {
      setFz();
    };
    function setFz() {
      /* 
        1 获取到当前的屏幕的宽度  =  要适配的屏幕的宽度
        2 计算html字体的大小   fontsize=基础值 * 要适配的屏幕的宽度 /  设计稿的宽度
        3 打开页面 直接调用该方法  屏幕的宽度改变之后 再调用一次这个方法 就可以动态改变html的字体
         */
      // 当前屏幕的宽度
      var screenWidth = document.querySelector("html").offsetWidth;
      // 基础值
      var baseVal = 100;
      // 设计稿的宽度
      var pageWidth = 1720;
      // 字体大小
      var fz = (baseVal * screenWidth) / pageWidth;
      //设置自动
      // document.querySelector("html").style.fontSize = fz + "px";
    }
    //获取设备树
    findDevicesList().then((res) => {
      if (res.code == 200) {
        // console.log("设备树",res);
        this.options = res.data;
        if (res.data.length != 0) {
          this.$store.cacheStore.commit("setDevice", {
            deviceName: res.data[0].deviceName,
            deviceNo: res.data[0].deviceNo,
          });
        }
      }
    });
  },
  methods: {
    getList() {},
    changed(i) {
      this.num2 = i;
      if (i) {
        this.$router.push({ path: "/figma" + (i + 1) });
      } else {
        this.$router.push({ path: "/figma" });
      }
    },
    //选择下拉框
    selectChange_fn(val) {
      var item = this.options.filter((item) => item.deviceNo == val);

      this.$store.cacheStore.commit("setDevice", item[0] || val);
    },
  },
};
</script>
<style>
.router {
  position: relative;
}

/* .apphome .el-table th.is-leaf, .apphome .el-table td{
    border: none;
   } */
</style>
<style scoped lang="scss">
.titled {
  height: 1rem;
  background: #fff;
  box-shadow: 0 0.08rem 0.16rem rgba(165, 200, 227, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  width: 100%;
}

/deep/.el-input__icon {
  line-height: 30px;
}

/deep/.el-input__inner {
  height: 30px;
}

/deep/.el-input {
  height: 30px;
}

/deep/.el-select {
  height: 30px;
}

.device {
  position: relative;
  /* width: 100%; */
}

.nowUnit-name {
  width: 250px;
  height: 30px;
  border: 1px solid #dcdfe6;
  text-align: center;
  line-height: 30px;
  /* margin-left: 5px; */
  border-radius: 5px;
}

.nowUnit-active {
  border: 1px solid #409eff;
}

.area-tree {
  position: absolute;
  max-width: 4rem;
  height: 4rem;
  /* margin-left: 4rem; */
  /* top: 0; */
  top: -9px;
  right: 0px;
  padding-top: 0.5rem;
  z-index: 99999;
  width: 100%;
}

.area-tree .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.titled .left {
  display: flex;
  align-items: center;
}

.titled .img {
  width: 0.64rem;
  height: 0.62rem;
  background: #ff7474;
  border-radius: 0.08rem;
  margin-left: 0.45rem;
  margin-right: 0.12rem;
}

.titled .img_txt .p {
  display: flex;
  align-items: center;
}

.titled .img_txt {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.titled .img_txt .p .nn {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 0.2rem;
  line-height: 0.24rem;
  color: #000;
  margin-right: 0.24rem;
}

.titled .img_txt .p .n {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 0.14rem;
  line-height: 0.17rem;
  color: #999999;
  margin-right: 0.15rem;
}

.titled .img_txt .p .t {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 0.16rem;
  line-height: 0.19rem;
  color: #4ca5ff;
}

.titled .right {
  height: 100%;
}

.titled .right .ul {
  display: flex;
  height: 100%;
}

.titled .right .ul .li {
  font-family: "Microsoft YaHei";
  font-style: normal;
  font-weight: 700;
  font-size: 0.18rem;
  line-height: 0.2rem;
  color: #999999;
  padding: 0 0.28rem;
  height: 100%;
  line-height: 1rem;
  cursor: pointer;
}

.titled .right .ul .li:hover {
  background: #4ca5ff;
  color: #fff;
}

.titled .right .ul .active {
  background: #4ca5ff;
  color: #fff;
}
</style>
